import React from "react";
import { Paths } from "./../constants/UrlConstants";
import { getPhone, getOpeningHours } from "../helpers/ContentStateHelper";
import { Link } from "react-router-dom";
import layoutStyle from "../assets/css/modules/shared/layout.css";

const GenericHelpSet = [
  {
    Question: "When and how can I make changes to my cover?",
    Answer: {
      Any: (props, params) => (
        <p>
          You can add options to your plan in the 14 days after you join us, or each year at your renewal once you’ve received your renewal documents.<br></br><br></br>
          You can remove or reduce options or cancel your plan at any time during the year.<br></br><br></br>
          To amend the options on your plan, we'll need to speak with you. <br></br><br></br>Please
          call us on {getPhone(props)}. Lines are open{" "}
          {getOpeningHours(props)}.
        </p>
      ),
      HOL: (props, params) => (
        <p>
          You can add options to your policy in the 14 days after you join us, or each year at your renewal once you’ve received your renewal documents.<br></br><br></br>
          You can remove or reduce options or cancel your policy at any time during the year.<br></br><br></br>
          To amend the options on your policy, we'll need to speak with you. <br></br><br></br>Please
          call us on {getPhone(props)}. Lines are open{" "}
          {getOpeningHours(props)}.
        </p>
      )
    }
  },
  {
    Question: "How do I see who's covered?",
    Answer: {
      Any: (
        <React.Fragment>
          <p>
            If you're the lead member, you can view everyone who's covered under
            your plan on the Cover details page, under 'Other people on my
            plan'.
          </p>
          <p>
            For confidentiality, if you're a family member, you can only view
            the lead member's details.
          </p>
        </React.Fragment>
      ),
      HOL: (
        <React.Fragment>
          <p>
            If you're the policyholder, you can view everyone who's covered
            under your policy on the Cover details page, under 'Other people on
            my policy'.
          </p>
          <p>
            For confidentiality, if you're a family member, you can only view
            the policyholder's details.
          </p>
        </React.Fragment>
      )
    }
  },
  {
    Question: "How do I change my personal details?",
    Answer: (props, params) => (
      <React.Fragment>
        <p>
          You can change your contact details and preferences in your profile.
        </p>
        <p>
          If you want to contact us about changing your name or payment date /
          method, please call our team of Personal Advisers on{" "}
          <strong>{getPhone(props)}</strong>. Lines are open{" "}
          {getOpeningHours(props)}.
        </p>
      </React.Fragment>
    )
  }
];

const LettersQuestions = [
  {
    Question: "How do I send you a completed letter of authority?",
    Answer: (
      <React.Fragment>
        <p>
          Once you've completed a{" "}
          <Link
            to={Paths.Permissions}
            className={"hol-link " + layoutStyle.anchorDecorationUnderline}
          >
            letter of authority
          </Link>
          , please scan and upload it via your inbox. You can attach it to a
          general enquiry.
        </p>
      </React.Fragment>
    )
  },
  {
    Question: "What do I need to use letters of authority for?",
    Answer: (
      <React.Fragment>
        <p>
          You can use a{" "}
          <Link
            to={Paths.Permissions}
            className={"hol-link " + layoutStyle.anchorDecorationUnderline}
          >
            letter of authority
          </Link>{" "}
          to allow us to discuss your medical details with a named individual,
          so that they can manage medical claims on your behalf. This can be
          found by navigating to "My account" - "Permissions".
        </p>
        <p>
          If you're the policyholder, you can also use a{" "}
          <Link
            to={Paths.Permissions}
            className={"hol-link " + layoutStyle.anchorDecorationUnderline}
          >
            letter of authority
          </Link>{" "}
          to give someone else permission to talk to us about general
          administration, payment of your subscriptions, changes to the policy,
          or changes to contact details.
        </p>
      </React.Fragment>
    )
  }
];

const HolHelpSet = GenericHelpSet.concat(LettersQuestions);

const MakeChangesToCover = {
  MakeChangesHeader: <h2>Make changes to cover</h2>,
  MakeChangesDescription: {
    Any: (props, params) => (
      <React.Fragment>
        <p>
          If you want to contact us about your cover or to make changes, please
          give us a call:
        </p>
        <p className="supportNumber">
          <strong>{getPhone(props)}</strong>
        </p>
        <p>{getOpeningHours(props)}</p>
        <br />
        <p>
          Our team of Personal Advisers are here to help you with queries
          including:
        </p>
        <ul>
          <li>Upgrading or downgrading your cover</li>
          <li>Adding or removing family members from your cover</li>
          <li>Plan renewals</li>
        </ul>
      </React.Fragment>
    ),
    HOL: (props, params) => (
      <React.Fragment>
        <p>
          If you want to contact us about your cover or to make changes, please
          give us a call:
        </p>
        <p className="supportNumber">
          <strong>{getPhone(props)}</strong>
        </p>
        <p>{getOpeningHours(props)}</p>
        <br />
        <p>
          Our team of Personal Advisers are here to help you with queries
          including:
        </p>
        <ul>
          <li>Amending your policy options within your cooling off period</li>
          <li>Adding or removing family members from your cover</li>
          <li>Policy renewals</li>
        </ul>
      </React.Fragment>
    )
  },
  HelpSection: {
    Any: {
      HeadingLinkTo: Paths.Help,
      HeadingLinkText: "Help",
      MoreHelpLinkTo: Paths.Help,
      MoreHelpLinkText: "View more help",
      HelpSet: GenericHelpSet
    },
    HOL: {
      HeadingLinkTo: Paths.Help,
      HeadingLinkText: "Help",
      MoreHelpLinkTo: Paths.Help,
      MoreHelpLinkText: "View more help",
      HelpSet: HolHelpSet
    }
  }
};

export default MakeChangesToCover;
